import { object, string, boolean } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const validationSchema = object().shape({
  content: string().trim().max(2000, 'Max length - 2000 symbols').required('Field is required'),
  isTelephoneConversation: boolean(),
  showReminder: boolean(),
  reminderDate: string()
    .nullable()
    .when('showReminder', {
      is: true,
      then: string().nullable().required('Field is required'),
    }),
  isSentForTriage: boolean(),
  issueName: string()
    .nullable()
    .when('isSentForTriage', {
      is: true,
      then: string().nullable().max(100, 'Max length - 100 symbols').required('Field is required'),
    }),
  isHighPriority: boolean(),
});

export default yupResolver(validationSchema);
